import React, { useState } from 'react'
import { Shield, Handshake, X, Loader2 } from 'lucide-react'
import { toast } from 'sonner'

const API = process.env.REACT_APP_BACKEND_URL

// Déclaration flotte directe : crée une fiche vierge (ASS ou AMI) que le gestionnaire remplit de A à Z
export default function DeclarationFlotteModal({ tenantId, policeId, onCreated, onClose }) {
  const [dateFait, setDateFait] = useState(new Date().toISOString().split('T')[0])
  const [saving, setSaving] = useState(null)

  async function creer(isAmiable) {
    if (!dateFait) { toast.error('Date de survenance requise'); return }
    setSaving(isAmiable ? 'amiable' : 'assurance')
    try {
      const res = await fetch(`${API}/api/sinistres`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tenant_id: tenantId, police_id: policeId, type_sinistre: 'flotte', date_fait: dateFait,
          est_amiable: isAmiable, mode_gestion: isAmiable ? 'amiable' : 'assurance',
          chauffeur_non_reference: true,
        }),
      })
      const data = await res.json()
      const newId = data.sinistre?.id || data.id
      if (!res.ok || !newId) { toast.error(data.detail || 'Erreur création'); return }
      toast.success(isAmiable ? 'Fiche amiable créée' : 'Fiche assurance créée')
      onCreated(newId)
    } catch { toast.error('Erreur de création') }
    finally { setSaving(null) }
  }

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 flex items-center justify-center p-4" data-testid="declaration-flotte-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
          <h2 className="font-bold text-slate-900">Déclaration flotte</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="declaration-flotte-close"><X size={18} /></button>
        </div>
        <div className="p-6 space-y-5">
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">Date de survenance</label>
            <input type="date" value={dateFait} onChange={e => setDateFait(e.target.value)}
              className="h-10 px-3 text-sm border border-slate-300 rounded-lg w-full" data-testid="declaration-flotte-date" />
            <p className="text-[11px] text-slate-400 mt-1">Tout le reste se remplit directement dans la fiche.</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <button onClick={() => creer(false)} disabled={!!saving} data-testid="declaration-flotte-assurance"
              className="flex flex-col items-center gap-2 p-5 rounded-xl border-2 border-blue-200 bg-blue-50 hover:border-blue-500 transition-colors disabled:opacity-50">
              {saving === 'assurance' ? <Loader2 size={22} className="animate-spin text-blue-600" /> : <Shield size={22} className="text-blue-600" />}
              <span className="text-sm font-bold text-blue-800">Fiche ASS</span>
              <span className="text-[11px] text-blue-600">Déclaration compagnie</span>
            </button>
            <button onClick={() => creer(true)} disabled={!!saving} data-testid="declaration-flotte-amiable"
              className="flex flex-col items-center gap-2 p-5 rounded-xl border-2 border-teal-200 bg-teal-50 hover:border-teal-500 transition-colors disabled:opacity-50">
              {saving === 'amiable' ? <Loader2 size={22} className="animate-spin text-teal-600" /> : <Handshake size={22} className="text-teal-600" />}
              <span className="text-sm font-bold text-teal-800">Fiche AMI</span>
              <span className="text-[11px] text-teal-600">Règlement amiable</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
